var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require("../assets/home.jpg"),"alt":""}}),_c('van-button',{staticClass:"generate2 buttonColor2",attrs:{"round":"","block":"","type":"info","native-type":"submit"},on:{"click":_vm.gotoDetail}},[_vm._v("开始测试")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }